import { useState } from 'react';

import Urls from '../../../../../constants/Urls';
import http from '../../../../../services/HttpService';
import UrlUtils from '../../../../../utils/url-utils/UrlUtils';
import LocalStorageService from '../../../../../services/local-storage-service/LocalStorageService';

import { highDemandAdapter } from '../../../../../business/highDemand/infra/adapters/highDemand.adapter';

export function useFetchStoreStatus() {
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState<any[]>([]);
  const [severityTimes, setSeverityTimes] = useState({});
  const clearState = () => {
    setIsError(false);
    setIsSuccess(false);
    setStores([]);
  };
  const fnFetch = () => {
    setIsLoading(true);
    setIsError(false);
    setIsSuccess(false);
    const baseUrl = LocalStorageService.getBaseUrl();
    const uri = UrlUtils.replaceUrlParams(
      Urls.SATURATION_LIST_BY_STORE_WITH_SEVERITY_TIMES,
    );
    setTimeout(() => {
      let localIsSuccess = false;
      http
        .get(`${baseUrl}${uri}`)
        .then(({ data }) => {
          localIsSuccess = true;
          setStores(
            data.stores.map(item => ({
              ...item,
              storeId: item.store_id,
              saturated: highDemandAdapter.toModelSaturation(item.saturated),
            })),
          );
          setSeverityTimes(
            Object.fromEntries(
              Object.entries(data['severity_times']).map((item: any) => [
                highDemandAdapter.toModelSaturation(item[0]),
                item[1].extra_minutes,
              ]),
            ),
          );
        })
        .catch(() => {
          localIsSuccess = false;
        })
        .finally(() => {
          setIsLoading(false);
          if (localIsSuccess) setIsSuccess(true);
          else setIsError(true);
        });
    }, 300);
  };
  return {
    isError,
    isSuccess,
    isLoading,
    fnFetch,
    stores,
    severityTimes,
    clearState,
  };
}
